import axios from "axios";

export default function EntrylocationShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/entry_location/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
